import { Component, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { NavigationService } from '../../services/navigation.service';
import { DiscResultsService } from 'discovery';
import { ScheduledDiscoveryResultDto } from 'UvExplorerServer.Dtos.TS/Discovery';
import { MessageService } from 'base';
import { IdentityService } from '../../../identity';
import { DevicesComponent } from 'netview';
import { ReportsComponent } from 'infosets';


@Component({
    selector: 'discresult',
	templateUrl: './discresult.component.html'
})
export class DiscResultComponent implements OnDestroy {

	public discResult: ScheduledDiscoveryResultDto;
	private locationChangedSub: Subscription;
	public selectedTab: number;
	
	@ViewChild(DevicesComponent)
	public devices: DevicesComponent;

	@ViewChild(ReportsComponent)
	public reports: ReportsComponent;

	public readonly DevicesTabIndex = 0;
	public readonly ReportsTabIndex = 1;
	public readonly EventsTabIndex = 2;

	constructor(
		private navService: NavigationService,
		private discResultsService: DiscResultsService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef,
		private identityService: IdentityService) {

		this.selectedTab = 0;

		this.getCurrentDiscResult();

		this.locationChangedSub = this.navService.onLocationChanged.subscribe(() => {
			this.getCurrentDiscResult();
		});
	}

	public ngOnDestroy(): void {
		if (this.locationChangedSub) {
			this.locationChangedSub.unsubscribe();
			this.locationChangedSub = undefined;
		}
	}

	public get isLoggedIn(): boolean {
		return this.identityService.isLoggedIn;
	}

	private getCurrentDiscResult(): void {
		this.discResult = new ScheduledDiscoveryResultDto();

		if (this.navService.location.hasSchedDiscRsltGuid) {
			//let netViewGuid = this.navService.location.netViewGuid;
			let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
			this.discResultsService.getSchedDiscResultByGuid(/*netViewGuid,*/ schedDiscRsltGuid, "raw").subscribe(
				(result: ScheduledDiscoveryResultDto) => {
					this.discResult = result;
					this.changeDetector.detectChanges();
				},
				(error?) => {
					this.messageService.displayErrorMessage("Could not retrieve discovery result");
				});
		}
	}
	
	public onTabChange(event: any): void {
		this.selectedTab = event.index;

		switch (this.selectedTab) {	
			case this.DevicesTabIndex:
				if (this.devices) {
					this.devices.reloadDeviceList();
				}
				break;
			case this.ReportsTabIndex:
				if (this.reports) {
					this.reports.reloadReport();
				}
				break;
		}
	}

}
